/** Cookie names shared across the pet-profile redirect middleware and the client-side store. */
export const COOKIE_NAMES = {
  audiences: 'pd_audiences',
  hasDogProfile: 'pd_has_dog_profile',
  hasCatProfile: 'pd_has_cat_profile',
  campaignSegment: 'pd_campaign_segment',
} as const;
